'use strict';
var EmblaCarousel = require('embla-carousel');
var emblaUtil = require('org/util/emblaCarousel');
const $cache = {
    document: $(document)
};
const slickConfigs = require('org/config/slickConfigs');

/**
 * Resolve slick-based slide settings for FYL Embla carousels.
 * @param {HTMLElement} rootNode - carousel root element
 * @returns {Object} slides config
 */
function getFylEmblaSlidesConfig(rootNode) {
    var slickConfig;

    if ($(rootNode).parents('.modal').length) {
        slickConfig = $(rootNode).parents('.modal-hypothesis').length ? slickConfigs.fylModalHyp : slickConfigs.fylModal;
    } else {
        slickConfig = slickConfigs.fyl;
    }

    return {
        slidesToShow: emblaUtil.getSlickOption(slickConfig, 'slidesToShow'),
        slidesToScroll: emblaUtil.getSlickOption(slickConfig, 'slidesToScroll') || 1
    };
}

/**
 * Init FYL Embla carousels
 */
function initFYLEmblaCarousels() {
    var carousels = document.querySelectorAll('.fyl-carousel.embla-slider');

    carousels.forEach(function (rootNode) {
        var slideCount = rootNode.querySelectorAll('.embla-slide').length;

        if (slideCount <= 1) {
            rootNode.classList.add('fyl-single');
            emblaUtil.destroyEmblaCarousel(rootNode);
            return;
        }

        rootNode.classList.remove('fyl-single');
        emblaUtil.initResponsiveEmblaCarousel(rootNode, EmblaCarousel, function () {
            return getFylEmblaSlidesConfig(rootNode);
        });
    });
}

/**
 * Init fyl related carousels (Slick - legacy)
 */
function initFYLCarousels() {
    let $carousel = $('.fyl-carousel:not(.embla-slider):not(.slick-initialized)');

    $carousel.each(function () {
        let slickConfig = (() => {
            var c = '';
            if ($(this).parents('.modal').length) {
                if ($(this).parents('.modal-hypothesis').length) {
                    c = slickConfigs.fylModalHyp;
                } else {
                    c = slickConfigs.fylModal;
                }
            } else {
                c = slickConfigs.fyl;
            }
            return c;
        })();
        let slickConfigSingle = $(this).parents('.modal').length ? slickConfigs.fylModalSingle : slickConfigs.fylSingle;

        if ($(this).find('div.product').length > 1) {
            $(this).slick(slickConfig);
        } else {
            $(this).addClass('fyl-single');
            $(this).slick(slickConfigSingle);
        }
    });

    initFYLEmblaCarousels();
}

/**
 * Product carousels ajax
 */
function getFylProducts() {
    let $fylWrap = $('.fyl-wrapper');
    var showFylLength = $fylWrap.data('fyl-showfyllength');
    var fylLength = $cache.document.data('fyl-length') || $fylWrap.data('fyl-length');

    let formData = {
        pid: $cache.document.data('fyl-pid') || $fylWrap.data('fyl-pid'),
        length: showFylLength ? fylLength : 'Regular',
        size: $cache.document.data('fyl-size') || $fylWrap.data('fyl-size'),
        color: $cache.document.data('fyl-color') || $fylWrap.data('fyl-color'),
        colortype: $cache.document.data('fyl-color-type') || 'solid'
    };
    let url = $('.fyl-swatches-wrapper').data('href');

    if (url && formData && formData.color && formData.colortype) {
        $.spinner().start();
        $.ajax({
            url: url,
            method: 'GET',
            data: formData,
            success: function (data) { // eslint-disable-line
                let $carouselsWrap = $('.fyl-carousels-wrapper');
                if ($carouselsWrap.length && data) {
                    $carouselsWrap.html(data);
                    initFYLCarousels();
                }

                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Hides the panels
 */
function closeRefinementsPanels() {
    $('.fyl-selectbar-panel').addClass('d-none');
    $('.fyl-selectbar-selector').removeClass('active').attr('aria-expanded', 'false');
}

module.exports = {
    methods: {
        initFYLCarousels
    },
    initEvents() {
        initFYLCarousels();

        // Scroll to pdp fyl tool event
        $cache.document.on('click', '.fyl-shortcut-el', function () {
            let $pdpTool = $('.fyl-pdp-tool');

            if ($pdpTool.length) {
                $('html, body').animate({
                    scrollTop: $pdpTool.offset().top - 150
                }, 500);
            }
        });

        // Swatch selection event
        $cache.document.on('click', '.fyl-swatch', function () {
            let $swatches = $('.fyl-swatch');
            // Don't run request for same result
            if ($(this).hasClass('selected')) {
                return;
            }

            $swatches.removeClass('selected');

            if ($(this).data('color-type') === 'print') {
                // Select print swatch
                $swatches.filter(`[data-color="${$(this).data('color')}"][data-color-type="print"]`).addClass('selected');
            } else {
                // Select current swatch in all instances on page
                $swatches.filter(`[data-color="${$(this).data('color')}"][data-color-type="solid"]`).addClass('selected');
            }

            $cache.document.data('fyl-color', $(this).data('color'));
            $cache.document.data('fyl-color-type', $(this).data('color-type'));
            getFylProducts();

            closeRefinementsPanels();
        });

        var fylKeyboardNav = false;

        $cache.document.on('blur', '.fyl-length-input, .fyl-size-input', function () {
            fylKeyboardNav = false;
        });

        $cache.document.on('keydown', '.fyl-length-input, .fyl-size-input', function (e) {
            if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                fylKeyboardNav = true;
            } else if (e.key === 'Enter') {
                e.preventDefault();
                fylKeyboardNav = false;
                if ($(this).hasClass('fyl-length-input')) {
                    $cache.document.data('fyl-length', $(this).val());
                } else {
                    $cache.document.data('fyl-size', $(this).val());
                }
                getFylProducts();
                closeRefinementsPanels();
            }
        });

        $cache.document.on('change', '.fyl-length-input', function () {
            if (fylKeyboardNav) {
                fylKeyboardNav = false;
                return;
            }
            $cache.document.data('fyl-length', $(this).val());
            getFylProducts();
            closeRefinementsPanels();
        });

        $cache.document.on('change', '.fyl-size-input', function () {
            if (fylKeyboardNav) {
                fylKeyboardNav = false;
                return;
            }
            $cache.document.data('fyl-size', $(this).val());
            getFylProducts();
            closeRefinementsPanels();
        });

        // Update swatch list when user chooses a variant
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('#quickViewModal.show').length === 0) {
                let $swatchWrapper = $('.fyl-swatches-wrapper');
                $swatchWrapper.empty();
                closeRefinementsPanels();
                $('.fyl-length-input, .fyl-size-input').prop('checked', false);

                if (response && response.data && response.data.product && response.data.product.fylSwatchArray) {
                    let fylSwatches = JSON.parse(response.data.product.fylSwatchArray);
                    let $swatchModel = $('.fyl-swatch-model .fyl-swatch-model-el');

                    // Sync variant attributes with fyl tool attributes
                    $cache.document.data('fyl-pid', response.data.product.id ? response.data.product.id : $('.product-detail').data('pid'));
                    $cache.document.data('fyl-length', response.data.product.length ? response.data.product.length : '');
                    $cache.document.data('fyl-size', response.data.product.variationAttributes[1] && response.data.product.variationAttributes[1].displayValue ? response.data.product.variationAttributes[1].displayValue : '');
                    $cache.document.data('fyl-color', response.data.product.selectedColor);
                    $cache.document.data('fyl-color-type', 'solid');
                    $('#fyl-size').val(response.data.product.variationAttributes[1] && response.data.product.variationAttributes[1].displayValue ? response.data.product.variationAttributes[1].displayValue : '');
                    $('.fyl-length-input[value="Regular"]').prop('checked', true);

                    // Fyl color swatches
                    if (fylSwatches && fylSwatches.length > 0 && response.data.product.fylProductsAvailable && response.data.product.fylProductsAvailable.length > 0) {
                        fylSwatches.forEach(swatchData => {
                            if (response.data.product.fylProductsAvailable.indexOf(swatchData.color) > -1) {
                                let $item = $swatchModel.eq(0).clone().removeClass('fyl-swatch-model-el');
                                let $swatch = $item.find('.fyl-swatch');
                                $swatch.attr({
                                    'data-color': swatchData.color,
                                    'data-hexcode': swatchData.hexcode,
                                    style: 'background: ' + swatchData.hexcode,
                                    'data-color-type': 'solid'
                                });
                                $item.find('.fyl-swatch-label').text(`${swatchData.colorName}`);

                                if (!swatchData.hexcode || swatchData.isLightColorSwatch) {
                                    $swatch.addClass('swatch-white');
                                }

                                if (response.data.product.selectedColor === swatchData.color || fylSwatches.length === 1) {
                                    $swatch.addClass('selected');
                                    $('.fyl-shortcut-el.btn').text(swatchData.colorName);
                                }

                                $swatchWrapper.append($item);
                            }
                        });
                    }

                    // Fyl prints
                    if (response.data.product.isPrintsAvailable) {
                        let $item = $swatchModel.eq(0).clone().removeClass('fyl-swatch-model-el');
                        let $swatch = $item.find('.fyl-swatch');
                        $swatch.attr({
                            'data-color': response.data.product.selectedColor ? response.data.product.selectedColor : '',
                            'data-color-type': 'print'
                        }).addClass('fyl-swatch-prints');
                        $item.find('.fyl-swatch-label').text(`${$swatchModel.data('resource-prints')}`);

                        $swatchWrapper.append($item);
                    }

                    var fylUrl = $swatchWrapper.data('href');
                    var form = {
                        pid: $swatchWrapper.data('pid'),
                        length: $swatchWrapper.data('length'),
                        color: response.data.product.selectedColor,
                        size: $swatchWrapper.data('size'),
                        colortype: 'solid'
                    };

                    getFylProducts(fylUrl, form);
                    if (fylSwatches.length > 0 && ((response.data.product.fylProductsAvailable && response.data.product.fylProductsAvailable.length > 0) || response.data.product.isPrintsAvailable)) {
                        $('.fyl-pdp-tool').removeClass('d-none');
                        $('.fyl-tool-wrapper').removeClass('d-none');
                    } else {
                        $('.fyl-tool-wrapper').addClass('d-none');
                        $('.fyl-pdp-tool').addClass('d-none');
                    }
                }
            }
        });

        // Reset FYL length to default after adding product to cart
        $('body').on('product:afterAddToCart', function () {
            $cache.document.data('fyl-length', 'Regular');
        });

        $cache.document.on('click', '.fyl-selectbar-selector', function () {
            let $this = $(this);
            let target = $this.data('target');
            let $context = $this.parents('.fyl-selection-context');

            if ($this.hasClass('active')) {
                $('.fyl-selectbar-selector', $context).removeClass('active').attr('aria-expanded', 'false');
                $('.fyl-selectbar-panel', $context).addClass('d-none');
            } else {
                $('.fyl-selectbar-selector', $context).removeClass('active')
                    .attr('aria-expanded', 'false').filter($(this))
                    .addClass('active')
                    .attr('aria-expanded', 'true');

                if (target) {
                    var $panel = $('.fyl-selectbar-panel', $context).addClass('d-none').filter(`[data-target="${target}"]`).removeClass('d-none');
                    $panel.find('input[type="radio"]:checked, input[type="radio"]:first').first().focus();
                }
            }
        });

        $cache.document.on('keydown', '.fyl-selectbar-selector', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('click');
            } else if (e.key === 'Escape') {
                closeRefinementsPanels();
                $(this).focus();
            }
        });

        $cache.document.on('keydown', '.fyl-selectbar-panel', function (e) {
            if (e.key === 'Escape') {
                var $selector = $(this).siblings('.fyl-selectbar-selector');
                closeRefinementsPanels();
                $selector.focus();
            }
        });
    }
};
